import React, { useState } from "react"
import { useMemo } from "react";
import Select from 'react-select'
import Helper from "../../helper";
import Application from "../../services/application.service";

const BankInfo = (props) => {
    var input = props.input;

    const typeArr = [{ value: "S", label: "Saving" }, { value: "F", label: "Fixed" }, { value: "SA", label: "Salary" }];
    const [acType, setActype] = useState(Helper.findByValue(input.account_type, typeArr));

    const handleSubmit = (e) => {
        e.preventDefault();

        input.account_type = (acType && acType.value) ? acType.value : '';

        var formData = Helper.convertFormData(input);
        formData.append('step', 'bank');

        Application.applicationUpdate(formData).then(res => {
            if (res.success === true) {
                props.setFormCount(7);
            }
        }).catch(err => console.log(err));
    }

    return (
        <>
            <div className="form-wrapper">
                <div className='form-head'>
                    <h2>Enter Your Bank Details </h2>
                </div>
                <div className="form-fields">
                    <div className="sub-form">
                        <h5 className="text-title mb-3">Your Credit Bank Details </h5>
                        <div className="row">
                            <div className="col-lg-6 col-md-12 form-group">
                                <label htmlFor="name">Name of Account Holder <span className="asterisk">*</span></label>
                                <div className="input-wrap d-flex">
                                    <input type="text" className="form-control" name="name" value={input.name} onChange={props.handleChange} />
                                </div>
                                <div className="validationAlert"></div>
                            </div>
                            <div className="col-lg-6 col-md-12 form-group">
                                <label htmlFor="name">Account Number <span className="asterisk">*</span></label>
                                <div className="input-wrap d-flex">
                                    <input type="text" className="form-control" name="account_number" value={input.account_number} onChange={props.handleChange} />
                                </div>
                                <div className="validationAlert"></div>
                            </div>
                            <div className="col-lg-6 col-md-12 form-group">
                                <label htmlFor="name">Bank <span className="asterisk">*</span></label>
                                <div className="input-wrap d-flex">
                                    <input type="text" className="form-control" name="bank_name" value={input.bank_name} onChange={props.handleChange} />
                                </div>
                                <div className="validationAlert"></div>
                            </div>
                            <div className="col-lg-6 col-md-12 form-group">
                                <label htmlFor="name">Account Type <span className="asterisk">*</span></label>
                                <div className="input-wrap d-flex">
                                    <Select options={typeArr} name="account_type" value={acType} onChange={val => setActype(val)} placeholder={'Select'}></Select>
                                </div>
                                <div className="validationAlert"></div>
                            </div>
                            <div className="col-lg-6 col-md-12 form-group">
                                <label htmlFor="name">Branch Name </label>
                                <div className="input-wrap d-flex">
                                    <input type="text" className="form-control" name="branch_name" value={input.branch_name} onChange={props.handleChange} />
                                </div>
                                <div className="validationAlert"></div>
                            </div>
                            <div className="col-lg-6 col-md-12 form-group">
                                <label htmlFor="name">Branch Code </label>
                                <div className="input-wrap d-flex">
                                    <input type="text" className="form-control" name="branch_code" value={input.branch_code} onChange={props.handleChange} />
                                </div>
                                <div className="validationAlert"></div>
                            </div>
                        </div>
                    </div>
                    <div className="note-wrapper mt-2">
                        <div id="collapseExample">
                            <div className="notes-list pt-4">
                                <p>Notes</p>
                                <div className="notes">
                                    <ul>
                                        <li>The account holder must have a South African bank account. </li>
                                        <li>Debit orders and electronic collections will be deducted from this account.</li>
                                        <li>The onus is on the investor to inform the Manager of any changes to the bank account details.</li>
                                        <li>No payments will be made into third party bank accounts or credit cards.(i.e.payments will only be made to the bank account in the name of the registered investor).</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="warning-msg"><span>*</span> Please note that you must fill the mandatory fields to submit the form.</div>
                </div>
            </div>
            <div className='form-actions'>
                <div className='row'>
                    <div className="col-12 pt-4">
                        <div className="button-wrapper ">
                            <button type="button" className="btn btn-ouline" onClick={e => props.setFormCount(5)} >Back</button>
                            <button type="button" className="btn btn-primary" onClick={handleSubmit}>Next</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BankInfo;